import React from 'react';
import PropTypes from 'prop-types';

const StopAddressWhenEdit = ({ rawAddress, className }) => (
  <div className={className}>{rawAddress}</div>
);

StopAddressWhenEdit.propTypes = {
  className: PropTypes.string,
  rawAddress: PropTypes.string,
};

StopAddressWhenEdit.defaultProps = {
  className: '',
  rawAddress: '',
};

export default StopAddressWhenEdit;
